import Swiper from 'swiper/swiper-bundle.min';
import 'swiper/swiper-bundle.min.css';
import throttle from 'lodash-es/debounce';
import Slider from '../slider';

export default () => {
  const $root = $('.filter');
  const $btns = $root.find('.filter__link');
  const $items = $root.find('.filter__item');
  const $slider = $root.find('.filter__slider');
  const $listBtn = $root.find('.filter__buttons');
  const $btnShow = $root.find('.filter__show');
  const $list = $root.find('.filter__list');
  let swiper;

    function handleFilter() {
    let isRender;

    $btns.on('click', (e) => {
      e.preventDefault();
      const $target = $(e.currentTarget);
      $btns.parent().removeClass('filter__button--active');
      $target.parent().addClass('filter__button--active');
      $items.removeClass('filter__item--hidden');
      $items.not($items.filter(`[data-type='${$target.data('type')}']`)).addClass('filter__item--hidden');

      if($target.data('type') === 0) {
        $items.removeClass('filter__item--hidden');
      }

      if($(window).outerWidth() <= 991){
        $items.removeClass('filter__item--hidden slide-down slide-up');
        if($target.data('type') !== 0) {
          $items.remove();
          $list.append($items);
          $items.not($items.filter(`[data-type='${$target.data('type')}']`)).remove();
          isRender = true;
          initSlider();
        }
        if($target.data('type') === 0 && isRender) {
          console.log($items);
          $list.append($items);
          initSlider();
          isRender = false;
        }
      }
    });
  }
  handleFilter();

  function initSwiper() {
    $slider.each((i,item)  => {
      const $target = $(item);
      const $slide = $target.find('.filter__slide');

      if($slide.length > 1) {
        swiper = new Swiper(item,{
          initialSlide: 0,
          slidesPerView: 1,
          spaceBetween: 20,
          loop: false,
          updateOnWindowResize: true,
          pagination: {
            el: '.filter__pagination',
            clickable: true
          },
          navigation: {
            nextEl: '.filter__btn-next',
            prevEl: '.filter__btn-prev',
          },
          lazy: true,
        })
      } else if($slide.length <= 1) {
        $target.addClass('filter__slider--no-slider')
      }
    });
  }
  initSwiper();

  $btnShow.on('click', (e) => {
    e.preventDefault();
    $listBtn.slideToggle();
    $listBtn.toggleClass('filter__buttons--visible');
    if($listBtn.hasClass('filter__buttons--visible')) {
      $btnShow.find('span').html('Скрыть планировки');
    } else {
      $btnShow.find('span').html('Показать планировки');
    }
  });

  function initSlider() {
    const slider = new Slider({
      wrapper: '.filter__list',
      slide: '.filter__item',
      btnNext: '.filter__key-next',
      btnPrev: '.filter__key-prev',
      infinite: false,
      disableBtnClass: 'filter__key--disabled'
    });
    if($(window).outerWidth() > 991){
      slider.destroySlider();
    }
  }
  initSlider();

  $(window).on('resize', throttle(() => {
    initSlider();
    if($listBtn.hasClass('filter__buttons--visible')){
      $listBtn.removeClass('filter__buttons--visible');
      if($(window).outerWidth() > 991){
        $listBtn.css('display', 'flex')
      }
    }
  },100));
}



// WEBPACK FOOTER //
// ./resources/assets/js/new-landing-constructor/filter/index.js